import { transport } from 'config/transport';

export function callApiSaveThuChiBanNganh(data) {
    return transport.put(`/bannganh/thuchi`, data);
}
